import { GiftCardJournalAction, GiftCardJournalActionInitiator } from 'shared/models'

const jounalActionText: Record<GiftCardJournalAction, string> = {
  GiftCardCreation: 'Создание сертификата',
  GiftCardCancellation: 'Отмена сертификата',
  GiftCardRedeem: 'Погашение сертификата',
  GiftCardStatusChanged: 'Изменение статуса',
  GiftCardPaymentStatusChanged: 'Изменение статуса оплаты',
  GiftCardStaffCommentChanged: 'Изменение комментария сотрудника',
  PaymentRequested: 'Оплата запрошена',
  PaymentConfirmed: 'Оплата подтверждена',
  PaymentRejected: 'Оплата отклонена'
}

const jounalInitiatorText: Record<GiftCardJournalActionInitiator, string> = {
  Auto: 'Автоматически',
  Backoffice: 'Бэк-офис',
  Site: 'Сайт'
}

export { jounalActionText, jounalInitiatorText }
